import { createFileRoute } from "@tanstack/react-router";
import { ClientInsightsScreen } from "../components/clients/ClientInsightsScreen";

export const Route = createFileRoute("/_auth/clients/$id_/insights")({
  staticData: {
    titleKey: "profile.insights.title",
    breadcrumbKey: "breadcrumb.clientsProfile",
  },
  component: ClientInsightsScreen,
});
